import axiosInstance from "../utils/axiosInstance";

const submitFormsApi = (url, formData) =>
  axiosInstance.post(`${url}`, formData).then(response => response);
export default submitFormsApi;
